import { render, staticRenderFns } from "./Kirim.vue?vue&type=template&id=12077de8&scoped=true"
import script from "./Kirim.vue?vue&type=script&lang=js"
export * from "./Kirim.vue?vue&type=script&lang=js"
import style0 from "./Kirim.vue?vue&type=style&index=0&id=12077de8&prod&lang=css"
import style1 from "./Kirim.vue?vue&type=style&index=1&id=12077de8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12077de8",
  null
  
)

export default component.exports